import script from "./heads.vue?vue&type=script&setup=true&lang=js"
export * from "./heads.vue?vue&type=script&setup=true&lang=js"

import "./heads.vue?vue&type=style&index=0&id=d2d6d022&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2d6d022"]])

export default __exports__